var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"privacy-policy-container"},[_c('iframe',{staticClass:"privacy-iframe",attrs:{"src":_vm.privacyUrl,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }